import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
//primereact
import { BreadCrumb } from "primereact/breadcrumb";
import { TabView, TabPanel } from "primereact/tabview";
//components
import Panel from "../../components/panel/panel";
//pages
import UserModules from "./Modules/UserModules";
import UserCreditCard from "./Creditcard/UserCreditCard";
import UserOpenPayments from "./Payments/UserOpenPayments";
import UserMadePayments from "./Payments/UserMadePayments";
//hook
import usePermission from "../../hooks/usePermission";

const UserRegistration = () => {
  usePermission("1"); //Visualizar Area do Cliente
  const { state } = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);

  const items = [
    {
      template: () => (
        <Link to={"/userRegistration"} className="p-breadcrumb-link">
          Área do Cliente
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  useEffect(() => {
    if (state?.index) {
      setActiveIndex(state.index);
    }
  }, [state]);

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <div>
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        <div>
          <Panel title="Área do Cliente">
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              {/* <TabPanel
                header="Módulos Contratados"
                leftIcon="fa-solid fa-layer-group me-2"
              >
                <UserModules />
              </TabPanel> */}
              {/* <TabPanel header="Planos" leftIcon="fa-solid fa-tags me-2">
                <UserPlans/>
              </TabPanel> */}
              <TabPanel
                header="Faturas Pendentes"
                leftIcon="pi pi-calendar me-2"
              >
                <UserOpenPayments />
              </TabPanel>
              <TabPanel
                header="Faturas Pagas"
                leftIcon="fa fa-check-to-slot me-2"
              >
                <UserMadePayments />
              </TabPanel>
              <TabPanel
                header="Cartão Cadastrado"
                leftIcon="fa fa-credit-card me-2"
              >
                <UserCreditCard />
              </TabPanel>
            </TabView>
          </Panel>
        </div>
      </div>
    </>
  );
};

export default UserRegistration;
